// extracted by mini-css-extract-plugin
export var current = "PaginationBottom-module--current--180c6";
export var disabled = "PaginationBottom-module--disabled--28b14";
export var pageItem = "PaginationBottom-module--page-item--9261a";
export var pageLink = "PaginationBottom-module--page-link--e1973";
export var pagination = "PaginationBottom-module--pagination--a2201";